export default "__VITE_ASSET__351510d5__"